import { useEffect, useState } from 'react';
import { timeUntilNextRange } from 'utils/time';

const useCountdown = (inQuantumWindow) => {
  const timeLeft = !inQuantumWindow ? timeUntilNextRange() : 0;

  const [countDown, setCountDown] = useState(timeLeft);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!inQuantumWindow) {
        setCountDown(timeUntilNextRange());
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [inQuantumWindow]);

  return !inQuantumWindow ? countDown : [0, 0, 0];
};

export default useCountdown;
